import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subscription, debounceTime } from 'rxjs';

@Directive({
  selector: '[appObserveElement]',
  exportAs: 'intersection',
  standalone: false,
})
export class ObserveElementDirective implements OnInit, OnDestroy {
  @Input() root: HTMLElement | null = null;
  @Input() rootMargin = '0px 0px 0px 0px';
  @Input() threshold = 0.5;
  @Input() debounceTime = 0;
  @Input() isContinuous = false;

  @Output() isIntersecting = new EventEmitter<boolean>();

  subscription: Subscription;
  intersecting = false;

  constructor(private element: ElementRef) {}

  ngOnInit() {
    this.subscription = this.createAndObserve();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  createAndObserve() {
    const options: IntersectionObserverInit = {
      root: this.root,
      rootMargin: this.rootMargin,
      threshold: this.threshold,
    };

    return new Observable<boolean>((subscriber) => {
      const intersectionObserver = new IntersectionObserver((entries) => {
        const isIntersecting = entries[0].isIntersecting;
        subscriber.next(isIntersecting);

        isIntersecting && !this.isContinuous && intersectionObserver.disconnect();
      }, options);

      intersectionObserver.observe(this.element.nativeElement);

      return {
        unsubscribe() {
          intersectionObserver.disconnect();
        },
      };
    })
      .pipe(debounceTime(this.debounceTime))
      .subscribe((status) => {
        if (status == true) {
          this.isIntersecting.emit(status);
        }
        this.intersecting = status;
      });
  }
}
